module.exports = __webpack_public_path__ + "img/feedTitle.f9f9d955.png";